import React from "react";
import { Field } from "react-final-form";
// import { EMAIL_VALIDATION, PASSWORD_VALIDATION } from "../../helpers";

export const RegisterUserComponent = (props) => {
  const submit = () => {
    return props.handleRegisterUserComponentSubmit(props.values)
  };

  return (
    <div className="RegisterUserComponent registration-page-step">
      <h3 className="registration-page-step__title">
        Welcome to 1stopvat, please enter your email Address
      </h3>

      <div className="registration-page-step__fields-wrapper">
        <div className="registration-input__wrapper">
          {(
            props.emailValidationStatus  === false 
            || props.passwordValidationStatus === false 
            || props.emailErrorMessage && (props.emailErrorMessage.length > 1)) 
          && (
            <span className="field-error-message">
            {
              props.emailValidationStatus === false && 'Email is not valid'
            }

            {
              props.emailErrorMessage && (props.emailErrorMessage.length > 1 && props.emailErrorMessage)
            }

            {
              (props.emailValidationStatus === false && props.passwordValidationStatus === false) && ' & '
            }

            {
              props.passwordValidationStatus === false && 'Password do not match'
            }
            </span>
          )}

          <Field
            className={
              "registration-input register-input " +
              ((props.emailValidationStatus === false && "field-error") || "")
            }
            name={props.emailContent.name}
            type="text"
            placeholder={props.emailContent.placeholder}
            key={props.emailContent.name}
            component="input"
            autoComplete="off"
            onBlur={props.removeEmailError}
          />

          <Field
            className={
              "registration-input register-input " +
              ((props.passwordValidationStatus === false && "field-error") ||
                "")
            }
            name={props.passwordContent.name}
            type={props.passwordContent.type}
            placeholder={props.passwordContent.placeholder}
            key={props.passwordContent.name}
            component="input"
            autoComplete="off"
            onBlur={props.removeEmailError}
          />

          <Field
            className={
              "registration-input register-input " +
              ((props.passwordValidationStatus === false && "field-error") ||
                "")
            }
            name={props.passwordRepeatContent.name}
            type={props.passwordRepeatContent.type}
            placeholder={props.passwordRepeatContent.placeholder}
            key={props.passwordRepeatContent.name}
            component="input"
            autoComplete="off"
            onBlur={props.removeEmailError}
          />
        </div>
      </div>

      <div className="registration-page-step__button-wrapper">
        <button
          type="button"
          className="registration-input registration-input__button"
          onClick={() => submit()}
        >
          proceed
        </button>
      </div>
    </div>
  );
};
